var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabsourse'),_c('div',{staticClass:"content clearfix"},[_c('div',{staticClass:"fl"},[_c('chapterContents')],1),_c('div',{staticClass:"fr",staticStyle:{"margin-left":"10px"}},[_c('courseCard')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }